const initialState = {
    list: {},
	translationSections: [],
    loaded: false,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case "LOAD_LANGUAGES":
            return {
                ...state,
                list: payload,
                loaded: true,
            };
		
		case "LOAD_TRANSLATION_SECTIONS":
			return {
				...state,
				translationSections: payload
			}

        default:
            return state;
    }
}
